import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import Select from "components/common/Select";
import FormAdvancedOptions from "./FormAdvancedOptions";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { pollingInterval } = formData;
  const availableContent = [
    { label: t("symantecedr.subscribe.content_events"), value: "EVENTS" },
    { label: t("symantecedr.subscribe.content_incidents"), value: "INCIDENTS" },
    { label: t("symantecedr.subscribe.content_audit_events"), value: "AUDIT_EVENTS" },
    { label: t("symantecedr.subscribe.content_system_activities"), value: "SYSTEM_ACTIVITIES" }
  ];
  const [contentTypes, setContentTypes] = useState("");
  const handleSubmit = () => {
    let error = false;
    formData.content_type.value = contentTypes;
    if (pollingInterval.value < 1) {
      setFormError({
        full_message: t("symantecedr.subscribe.invalid_polling_interval_message"),
        nice_message: t("symantecedr.subscribe.min_polling_interval")
      });
      error = true;
    }
    if (!error) {
      setFormError(null);
      onSubmit();
    }
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.proceed"),
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contents" }, t("symantecedr.subscribe.log_types_label")),
    /* @__PURE__ */ React.createElement(
      Select,
      {
        multi: true,
        name: "content_type",
        id: "content_type",
        onChange: (selected) => setContentTypes(selected),
        options: availableContent,
        value: contentTypes
      }
    ),
    /* @__PURE__ */ React.createElement("span", { className: "help-block" }, t("symantecedr.subscribe.log_types_help")),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pollingInterval",
        name: "pollingInterval",
        type: "number",
        value: pollingInterval.value || pollingInterval.defaultValue || "",
        min: "1",
        max: "60",
        step: "1",
        onChange,
        required: true,
        help: t("symantecedr.subscribe.polling_interval_help"),
        label: t("common.fields.polling_interval")
      }
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange })
  );
};
export default StepSubscribe;
